import styled from "styled-components";

export const Container = styled.div``;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 180px;

  & button {
    background-color: transparent;
    border: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

interface Props {
  active?: boolean;
}

export const Icon = styled.i<Props>`
  font-size: 1.5rem;
  color: var(--input-rate-color);
  opacity: ${(props) => (props.active ? "1" : "0.4")};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 0.5rem;
  &:last-child {
    margin-right: 0;
  }
  & svg {
    fill: ${(props) => (props.active ? "var(--input-rate-color)" : "none")};
  }
`;
